import { BlobServiceClient, BlockBlobClient } from '@azure/storage-blob'
import { sasNeedsRefresh } from './SasHelpers'
import ApiServer from './api/ApiServer'
import { SasTokenLocations } from './LocalStorageActor'

class EudrClient {
  async getEndpoint () {
    return 'companyinfo/blobinfo/eudr'
  }

  // Rebuilds the BlobServiceClient only when the cached SAS is missing, unreadable, or near expiry —
  // the same shape as ExportBatchDocumentArchiveClient.checkForRefresh — instead of constructing fresh
  // clients on every fetch. A corrupt capsule falls through to a refetch rather than throwing.
  async initConnection () {
    const capsule = this.readStoredCapsule()
    if (capsule === null || sasNeedsRefresh(capsule.blobSasUri)) {
      const endpoint = await this.getEndpoint()
      const response = await ApiServer.get(ApiServer.urlFor(endpoint))
      localStorage.setItem(SasTokenLocations.EUDR_REPORT_SAS, JSON.stringify(response))
      this.client = null
    }

    if (!this.client) {
      const stored = this.readStoredCapsule()
      this.container = stored.container
      this.location = stored.location
      this.client = new BlobServiceClient(stored.blobSasUri)
      this.containerClient = this.client.getContainerClient(this.container)
    }
  }

  readStoredCapsule () {
    try {
      const parsed = JSON.parse(localStorage.getItem(SasTokenLocations.EUDR_REPORT_SAS))
      const entry = parsed?.data?.[0]
      return entry?.blobSasUri ? entry : null
    } catch (e) {
      return null
    }
  }

  // resultBlobPath is the full container-relative path returned by the server
  // (e.g. "CONTENT/EUDR/{id}/eudr_{destination}_{id}.json"), so it is used as-is.
  // Do NOT prepend this.location — the SAS location prefix is already part of the path.
  async fetchReportBlob (resultBlobPath) {
    await this.initConnection()
    const blobClient = this.containerClient.getBlobClient(resultBlobPath)
    const response = await blobClient.download()
    return await response.blobBody
  }

  // Write a validation artifact with a per-blob write SAS issued by the server (eudr/{id}/writesas).
  // The SAS is scoped to one canonical blob path with a short expiry, so it is used directly, not cached.
  async uploadBlobWithSas (sasUri, jsonString) {
    const blockBlobClient = new BlockBlobClient(sasUri)
    const content = new Blob([jsonString], { type: 'application/json' })
    await blockBlobClient.uploadData(content, { blobHTTPHeaders: { blobContentType: 'application/json' } })
  }
}

export const eudrClient = new EudrClient()
